<template>
  <div id="app">
    <myhead title="VIP服务"></myhead>
    <div class="page">
      <centerInfo :userInfo="userInfo"></centerInfo>

      <div v-if=" userInfo.viptype == 3 ">
        <vipYong :yongvip="yongvip"></vipYong>
      </div>
      <div v-else>
        <div v-if="userInfo.viptype == 1 || userInfo.viptype == 2">
          <vipOpenButton :userInfo="userInfo"></vipOpenButton>
          <vipDesc :userInfo="userInfo"></vipDesc>
          <vipContent :userInfo="userInfo"></vipContent>
        </div>

        <div v-else>
          <vipOpenContent></vipOpenContent>
          <vipContent :userInfo="userInfo"></vipContent>
          <vipDesc :userInfo="userInfo"></vipDesc>
        </div>

        <div class="app-state">
          <img src="../../assets/img/vip-declare@2x.png" alt />
          <br />
          <div class="app-state-desc">
            <span>
              所有环节均采用金融级加密技术
              <br />极致的保护隐私，是我们共同的追求
            </span>
          </div>
        </div>
        <vipBotton></vipBotton>
      </div>
    </div>
  </div>
</template>
<script>
import myhead from "../common/head";
import centerInfo from "../common/centerInfo";
import vipOpenContent from "../common/vipOpenContent";
import vipOpenButton from "../common/vipOpenButton";
import vipContent from "../common/vipContent";
import vipDesc from "../common/vipDesc";
import vipBotton from "../common/vipBotton";
import vipYong from "../common/vipYong";
import store from "../../store/index";
import * as types from "../../store/types";
import { mapGetters } from "vuex";

export default {
  metaInfo: {
    title:"VIP服务",
  },
  name: "app",
  data() {
    return {
      msg: "VIP服务",
      userInfo: { viptype: 3 },
      yongvip: {
        titles: ["土豪专享!安臻之选!"],
        descs: ["联系客服，私人定制伪装App", "因为独一无二·所以最安全"]
      },
      list: []
    };
  },
  mounted() {
    this.$point.init(new Date());
    store.dispatch('hideLoading');    
    
    this.userInfo = this.getUserInfo;

    var token = this.getToken;
    var listData = this.getUserList;
    var token = this.getToken;
    console.log("store里面的toekn有值" + JSON.stringify(token));
    if (token == null || token == "") {
      token = localStorage.getItem("token");
      console.log("localStorage缓存token：" + token);
      store.commit(types.LOGIN, token);
    }
    if (token == "" || token == null) {
      this.$router.push("/login");
    }
  },
  created(){
      this.userInfo = this.getUserInfo;
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList"
    ])
  },
  components: {
    myhead,
    centerInfo,
    vipOpenContent,
    vipOpenButton,
    vipContent,
    vipDesc,
    vipBotton,
    vipYong
  }
};
</script>
<style  scoped>
.page {
  width: 750px;
  height: auto;
  background-image: url("../../assets/img/background@2x.png");
  padding: 28px 0px 40px 0px;
  background-size: cover;
}

.app-state {
  width: 100%;
  height: auto;
}

.app-state img {
  width: 130px;
  height: 10px;
}
.app-state-desc {
  width: 100%;
  height: 76px;
  margin: 26px auto 130px auto;
}

.app-state span {
  width: 384px;
  height: 76px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 34px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/userVip.vue